'use client';

import {useEffect, useState} from 'react';
import {PauseIcon, PlayIcon} from '@heroicons/react/20/solid';
import clsx from 'clsx';

import {VideoPlayer} from '../../video-player';
import {useHero} from '../context/page-head-context';
import type {VideoFullscreenPageHead} from '../types';

type Props = {
	pageHead: VideoFullscreenPageHead;
};

export const VideoFullscreen = ({pageHead}: Props) => {
	const {video, title, tagline} = pageHead ?? {};
	const [isPlaying, setIsPlaying] = useState(true);

	const {setDarkHero} = useHero();

	useEffect(() => {
		setDarkHero(true);

		// Reset the context when the component unmounts
		return () => setDarkHero(false);
	}, [setDarkHero]);

	return (
		<>
			<div
				className={clsx(
					'h-[calc(80dvh-7rem)]',
					'lg:h-[calc(80dvh-11rem)]',
					'relative',
					'w-full',
					'mb-16',
					'sm:mb-32',
				)}
			>
				<button
					onClick={() => setIsPlaying((prev) => !prev)}
					className={clsx(
						'bg-black/30',
						'absolute',
						'bottom-5',
						'right-5',
						'z-10',
						'size-[48px]',
						'rounded-full',
						'text-beige-500',
						'flex',
						'justify-center',
						'items-center',
					)}
				>
					{isPlaying && <PauseIcon className={clsx('size-8')} />}
					{!isPlaying && <PlayIcon className={clsx('size-8')} />}

					<span className={clsx('sr-only')}>
						{isPlaying ? 'Pause' : 'Play'}
					</span>
				</button>
				<div
					className={clsx(
						'absolute',
						'-top-28',
						'lg:-top-44',
						'w-screen',
						'left-[calc(50%-50vw)]',
						'bottom-0',
						'-z-20',
						'bg-forestGreen-500',
						'pointer-events-none',
					)}
				>
					{video && video.title && video.id && (
						<VideoPlayer
							video={{
								title: video.title,
								id: video.id,
							}}
							autoplay
							cover
							paused={!isPlaying}
							darken={video.darken}
						/>
					)}
				</div>
				<div
					className={clsx(
						'w-full',
						'max-w-screen-xl',
						'mx-auto',
						'px-6',
						'h-full',
						'flex',
						'items-center',
						'text-beige-500',
						'pointer-events-none',
						'z-50',
					)}
				>
					<div
						className={clsx(
							'flex',
							'flex-col',
							'gap-y-4',
							'md:gap-y-12',
							'gap-x-24',
							'max-w-2xl',
							'pointer-events-none',
						)}
					>
						<h1
							className={clsx(
								'text-h3',
								'sm:text-h1',
								'col-start-1',
								'w-full',
							)}
						>
							{title}
						</h1>
						<div
							className={clsx(
								'text-xs',
								'font-medium',
								'sm:text-pMedium',
								'col-start-1',
							)}
						>
							{tagline}
						</div>
					</div>
				</div>
			</div>
			{/*<div className={clsx('w-full', 'max-w-screen-xl', 'mx-auto', 'px-6', 'mb-12')}>*/}
			{/*	IKONLISTE*/}
			{/*</div>*/}
		</>
	);
};
